import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { Session } from 'src/shared/session';

import type { PromotePageMainData as PromotePageMainDataReturn } from '../types';

import {
	PromotePageMainData,
	type PromotePageMainDataQuery,
	type PromotePageMainDataQueryVariables,
} from './getPromotePageMainData.graphql';
import { normalize } from './normalize';

export type PromotePageMainDataParams = {
	slug: string;
	countryCode: string;
	locale: string;
	path: string;
	loginState: Session['loginState'];
	amountId?: string;
	comboBanditAmount?: number;
	stateCode?: string;
};

export async function getPromotePageMainData(
	{ gql: { fetch } }: UtilityContext,
	{ slug, countryCode, locale, amountId, comboBanditAmount, stateCode }: PromotePageMainDataParams,
): Promise<PromotePageMainDataReturn> {
	const { data } = await fetch<PromotePageMainDataQuery, PromotePageMainDataQueryVariables>({
		query: PromotePageMainData,
		variables: {
			slug,
			locale,
			countryCode,
			chipInAmount: comboBanditAmount || 0,
			chipInAmountId: amountId || '',
			fetchContextualButtons: !!(amountId && comboBanditAmount),
			stateCode: stateCode || null,
		},
		rejectOnError: true,
	});

	return normalize(data);
}
